module.exports = __webpack_public_path__ + "img/solutions--moving_immobile_patient.63611957.png";